import { Injectable } from '@angular/core';
import { QuerifyService } from '@core/services/querify.service';
import { Approval, PagedResult } from '@interfaces';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Mutations } from './mutations';
import { Queries } from './queries';

@Injectable({
  providedIn: 'root'
})
export class ApprovalsEquipmentsApi {
  constructor(
    private apollo: Apollo,
    private queries: Queries,
    private mutations: Mutations,
    private querify: QuerifyService
  ) { }

  searchApprovalsEquipments(query?, options?): Observable<PagedResult> {
    options = this.querify.transformOptions(query, options);
    return this.apollo
      .query({
        query: this.queries.getApprovalsEquipments(),
        variables: options
      })
      .pipe(
        map(({ data }) => {
          return data['approvals'];
        })
      );
  }

  searchOne(id): Observable<Approval> {
    return this.apollo
      .query({
        query: this.queries.getApprovalEquipment(),
        variables: { id: id }
      })
      .pipe(
        map(({ data }) => {
          return data['approval'];
        })
      );
  }

  acceptEquipment(id, message): Observable<Approval> {
    return this.apollo
      .query({
        query: this.mutations.acceptEquipment(),
        variables: { id: id, reason: message }
      })
      .pipe(
        map(({ data }) => {
          return data['acceptEquipment'];
        })
      );
  }

  refuseEquipment(id, message): Observable<Approval> {
    return this.apollo
      .query({
        query: this.mutations.refuseEquipment(),
        variables: { id: id, reason: message }
      })
      .pipe(
        map(({ data }) => {
          return data['refuseEquipment'];
        })
      );
  }
}
